exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#container{margin-top:115px}", "", {"version":3,"sources":["C:/Users/chris/projetos/GrupoPrepago/src/components/Colaboradores.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"Colaboradores.vue","sourcesContent":["\n#container {\n  margin-top: 115px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2dc3d8e8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Colaboradores.vue
// module id = 540
// module chunks = 2